import React from 'react';

const WhyGlodesk = () => {
    const cards = [
        {
            title: 'Scattered Employee Data',
            description: 'Records spread across multiple disconnected systems'
        },
        {
            title: 'Manual Attendance Tracking',
            description: 'Time-consuming, error-prone leave management'
        },
        {
            title: 'Slow Payroll Processing',
            description: 'Hours lost to manual salary calculations'
        },
        {
            title: 'Lengthy Approval Workflows',
            description: 'Requests stall without clear ownership'
        }
    ];

    return (
        <section className="w-full bg-white pb-16 lg:pb-24 overflow-hidden select-none">
            <div className="max-w-[1440px] w-full mx-auto px-6 lg:px-16 flex flex-col items-center text-center">

                <h2 className="text-[20px] sm:text-[30px] font-sora font-[600] text-[#01386A] tracking-tight mb-16">
                    Why Glodesk?
                </h2>

                <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            className="group relative flex flex-col justify-between p-8 min-h-[337px] bg-white text-[#01386A] border border-[#01386A45] hover:text-white transition-all duration-500 ease-out overflow-hidden shadow-xs cursor-pointer"
                        >
                            <div className="absolute inset-0 bg-[#0A4373] transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out z-0" />
                            <div className="absolute bottom-0 left-0 w-full h-[4px] z-20">
                                <div className="absolute bottom-0 left-0 h-full w-full bg-[#0A4373] scale-x-0 origin-left group-hover:scale-x-100 group-hover:bg-orange-500 transition-all duration-500 ease-out" />
                            </div>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] z-10">
                                <div className="absolute bottom-0 left-0 h-full w-full bg-[#0A4373]/5 origin-left" />
                            </div>

                            <h3 className="text-[16px] lg:text-[20px] font-[600] font-sora tracking-tight leading-snug relative z-10 text-[#01386A] group-hover:text-white transition-colors duration-500 text-left">
                                {card.title}
                            </h3>

                            <p className="text-[14px] lg:text-[16px] font-graphik h-[72px] font-[500] leading-relaxed relative z-10 text-[#49577A] group-hover:text-gray-200 transition-colors duration-500 text-left">
                                {card.description}
                            </p>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default WhyGlodesk;